import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { MapAndTransformOutputContainer } from "../containers";
import {
  MapAndTransform,
  Aggregate,
  ReviewAndConfirm,
  Ruleset,
  LoadDefinitionHome,
  LoadDefinitionSource,
  AssociatePlans,
  LoadFilter,
  Scheduler,
  TargetContainers,
  VerifyMap,
  VerifyMapOutput,
  Overview,
  FixedLength,
  OutputTarget,
  Preview,
  Ruletab,
  Split,
} from "../layouts";

import { MANAGE_MAPPER_ROUTES, ApplicationRoute, ROUTES } from "../utils";
import OutputFilter from "./../layouts/Mapper/OutputFilter/OutputFilter";

const menu = "mapper";
export const ManageMapperRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.OVERVIEW}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.OVERVIEW}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Overview}
        //component={MapAndTransformOutputContainer}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={MapAndTransform}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM_OUTPUT}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM_OUTPUT}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={MapAndTransformOutputContainer}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={VerifyMapOutput}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.AGGREGATE}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.AGGREGATE}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Aggregate}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.REVIEW_AND_CONFIRM}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.REVIEW_AND_CONFIRM}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={ReviewAndConfirm}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.SPLIT}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.SPLIT}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Split}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.RULESET}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.RULESET}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Ruleset}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.SCHEDULER}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.SCHEDULER}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Scheduler}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.BASIC_INFORMATION}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.BASIC_INFORMATION}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={LoadDefinitionHome}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.SOURCE}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.SOURCE}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={LoadDefinitionSource}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.PREVIEW}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.PREVIEW}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Preview}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.VALIDATIONS}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.VALIDATIONS}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={Ruletab}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.ASSOCIATEDPLANS}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.ASSOCIATEDPLANS}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={AssociatePlans}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.VERIFY_MAP}/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.VERIFY_MAP}/:flow(add|edit|save)/:mapType?/:profileId?`,
        ]}
        component={VerifyMap}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.FILTER}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.FILTER}/:mapType?/:profileId?`,
        ]}
        component={LoadFilter}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.OUTPUT_FILTER}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.OUTPUT_FILTER}/:mapType?/:profileId?`,
        ]}
        component={OutputFilter}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.TARGET}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.TARGET}/:mapType?/:profileId?`,
        ]}
        component={TargetContainers}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.FIXED_LENGTH}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.FIXED_LENGTH}/:mapType?/:profileId?`,
        ]}
        component={FixedLength}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.OUTPUT_TARGET}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.OUTPUT_TARGET}/:mapType?/:profileId?`,
        ]}
        component={OutputTarget}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_MAPPER_ROUTES.PASSTHROUGH_TARGET}/:flow(add|edit|save)/:mapType?/:profileId?`,
          `${MANAGE_MAPPER_ROUTES.PASSTHROUGH_TARGET}/:mapType?/:profileId?`,
        ]}
        component={OutputTarget}
      />
      <Redirect
        exact
        menu={menu}
        from={ROUTES.MANAGE_MAPPER}
        to={MANAGE_MAPPER_ROUTES.OVERVIEW}
      />
    </Switch>
  );
};
